<template>
    <v-row no-gutters class="pa-2 mt-4">
        <!-- <v-col cols="4" class="d-flex py-2">
            <setting-task :config="config" @updateProfile="updateProfile()" />
        </v-col> -->
        <v-col cols="4" class="d-flex py-2">
            <SettingExpenseAndIncome :config="config" @updateProfile="updateProfile()" />
        </v-col>
        <v-col cols="4" class="d-flex py-2">
            <setting-document-from-mail
                :config="config"
                :companyId="companyId"
                :profileId="profileId"
                :forMyCompany="true"
                @updateProfile="updateProfile()"
                @onUpdate="refresh"
            />
        </v-col>
        <v-col cols="4" class="d-flex py-2">
            <SettingBobbeeCollect
                :config="config"
                :companyId="companyId"
                :profileId="profileId"
                :forMyCompany="true"
                @updateProfile="updateProfile()"
                @onUpdate="refresh"
            />
        </v-col>
        <v-col cols="4" class="d-flex py-2" v-if="isAllowedToInvoice">
            <SettingSendingMailSMTP
                ref="setting-sending-mail-smtp"
                :config="config"
                :profileId="profileId"
                :companyId="companyId"
                :readonly="readonly"
                @updateProfile="updateProfile()"
                @onUpdate="refresh"
            />
        </v-col>
        <v-col cols="4" class="d-flex py-2">
            <setting-declaration
                :config="config"
                :companyId="companyId"
                :incomeCategory="companyIncomeCategory"
                @updateProfile="updateProfile()"
            />
        </v-col>
        <v-col cols="4" class="d-flex py-2">
            <setting-others :config="config" @updateProfile="updateProfile()" />
        </v-col>
        <v-col cols="4" class="d-flex py-2">
            <setting-payment
                :config="config"
                :companyId="companyId"
                @updateProfile="updateProfile()"
            />
        </v-col>
        <v-col cols="4" class="d-flex py-2">
            <setting-workflow
                :config="config"
                :companyId="companyId"
                @updateProfile="updateProfile()"
            />
        </v-col>
        <v-col cols="4" class="d-flex py-2" v-if="isAllowedToStock">
            <setting-stock
                :config="config"
                :companyId="companyId"
                @updateProfile="updateProfile()"
            />
        </v-col>
        <v-col cols="4" class="d-flex py-2">
            <SettingManagementAuthorizations
                :config="config"
                :companyId="companyId"
                :profileId="profileId"
                :forMyCompany="true"
                @updateProfile="updateProfile()"
                @onUpdate="refresh"
            />
        </v-col>
        <!-- <v-col cols="4" v-if="companyLegalForm === 'SCI'">
            <SettingSCI
                :config="config"
                :companyId="companyId"
                @updateProfile="updateProfile()"
            ></SettingSCI>
        </v-col> -->
        <!-- <v-col cols="4">
            <setting-stripe
                :config="config"
                :companyId="companyId"
                @updateProfile="updateProfile()"
            ></setting-stripe>
        </v-col> -->
    </v-row>
</template>

<script lang="ts">
import _ from "lodash";
import { User } from "../../store/store";

import SettingTask from "../configuration/settings/SettingTask.vue";
import SettingExpenseAndIncome from "../configuration/settings/SettingExpenseAndIncome.vue";
import SettingDocumentFromMail from "../configuration/settings/SettingDocumentFromMail.vue";
import SettingDeclaration from "../configuration/settings-old/SettingDeclaration.vue";
import SettingOthers from "../configuration/settings-old/SettingOthers.vue";
import SettingPayment from "../configuration/settings-old/SettingPayment.vue";
import SettingSendingMailSMTP from "../configuration/settings/SettingSendingMailSMTP.vue";
import SettingConnector from "../configuration/settings/SettingConnector.vue";

import SettingWorkflow from "../configuration/settings/SettingWorkflow.vue";
import SettingStock from "../configuration/settings/SettingStock.vue";
import SettingSCI from "../configuration/settings/SettingSCI.vue";
import SettingManagementAuthorizations from "../configuration/settings/SettingManagementAuthorizations.vue";
import SettingBobbeeCollect from "../configuration/settings/SettingBobbeeCollect.vue";

import { Apollo } from "@/decorators";

import PROFILE_COMPANY from "../../graphql/company/ProfileCompany.gql";
import GET_COMPANY_OFFER from "@/graphql/company/GetCompanyOffer.gql";
import UPSERT_PROFILE_COMPANY from "../../graphql/UpsertProfileCompany.gql";

import { ProfileCompany } from "../../models/profileCompany.types";
import { Component, Vue, toNative } from "vue-facing-decorator";
import { Prop } from "vue-facing-decorator";
import { Watch } from "vue-facing-decorator";
import { OfferAccessRight } from "../../services/accessRightServices";
import { Offer_type } from "@/types/offer.types";

// const BobbeeImg = require("../../assets/img/bobbee3d/bobbee3dTuto.png");

@Component({
    components: {
        SettingTask,
        SettingExpenseAndIncome,
        SettingDocumentFromMail,
        SettingDeclaration,
        SettingOthers,
        SettingPayment,
        SettingSendingMailSMTP,
        SettingWorkflow,
        SettingStock,
        SettingSCI,
        SettingConnector,
        SettingManagementAuthorizations,
        SettingBobbeeCollect,
    },
})
export class ConfigAPI extends Vue {
    @Prop({ default: "" }) companyId: string;
    @Prop({ default: "" }) inProfileId: string;
    @Prop() companyIncomeCategory: string;
    @Prop() companyTaxSystemType: string;
    @Prop() companyLegalForm: string;
    switch1: boolean = false;
    btnCar: boolean = false;
    btnMoto: boolean = false;
    btnMoped: boolean = false;

    list = [];
    listLabel = [];
    dialog: boolean = false;

    get binds() {
        return {
            lastImportDate: new Date(),
        };
    }

    get isAllowedToInvoice() {
        return OfferAccessRight.checkOfferAccessRight("isAllowedToInvoice", false, this.offerType);
    }

    get isAllowedToStock() {
        return OfferAccessRight.checkOfferAccessRight("isAllowedToStock", false, this.offerType);
    }

    get currentUser(): User {
        return this.$store.state.user;
    }

    // get bobbeeImg() {
    //     return BobbeeImg;
    // }

    profileId_ = null;

    get profileId() {
        if (this.profileId_) {
            return this.profileId_;
        }
        return this.inProfileId;
    }

    get readonly(): boolean {
        return (
            this.companyId === this.$store.state.user.company.id &&
            this.$store.state.user.company.accountingFirm
        );
    }

    get bundleRofPrefix() {
        switch (this.companyIncomeCategory) {
            case "BIC": {
                if (this.companyTaxSystemType === "IR") {
                    return "BIC";
                }
                return "IS";
            }
            case "BNC": {
                return "BNC";
            }
            case "BA": {
                return "BA";
            }
            case "RF": {
                return "RF";
            }
            default: {
                return "BIC";
            }
        }
    }

    async updateProfile() {
        const result = await this.$apollo.mutate({
            mutation: UPSERT_PROFILE_COMPANY,
            variables: {
                ...this.config,
                companyId: this.companyId,
                id: this.profileId || "",
                vatBankAccountUpdate: this.config.vatBankAccount.id
                    ? {
                          connect: {
                              id: this.config.vatBankAccount.id,
                          },
                      }
                    : undefined,
                vatBankAccountCreate: this.config.vatBankAccount.id
                    ? {
                          connect: {
                              id: this.config.vatBankAccount.id,
                          },
                      }
                    : undefined,
                ogaEnrolmentConfig: this.config.ogaEnrolment
                    ? this.config.ogaEnrolmentConfig
                    : {
                          numberId: "",
                          siret: "",
                          designation: "",
                          address: "",
                          postalCode: "",
                          city: "",
                          year: "",
                      },
                managementAuthorizations: {
                    supplier: this.config.managementAuthorizations.supplier,
                    client: this.config.managementAuthorizations.client,
                    expenseReport: this.config.managementAuthorizations.expenseReport,
                    salary: this.config.managementAuthorizations.salary,
                    operatingAccount: this.config.managementAuthorizations.operatingAccount,
                },
                managementAuthorization: this.config.managementAuthorization,
                mailCollectKey: this.config.mailCollectKey,
                mailCollect: this.config.mailCollect,
            },
        });
        if (this.inProfileId && this.inProfileId !== result.data.upsertProfileCompany.id) {
            debugger;
        }
        this.profileId_ = result.data.upsertProfileCompany.id;

        this.$router.push({ path: `/companies/${this.companyId}`, force: true });
    }

    defaultConfig: ProfileCompany = {
        //don't forget to modify config in apollo when you modify this Json
        accountingType: "RECEIVABLES_DEBT",
        createZTillReceipt: true,
        zTillReceiptWithTransactions: false,
        createExpenseReport: true,
        createPaySlip: true,
        createSalesInvoice: true,

        taxeApprentissage: false,
        taxeSurLesSalaires: false,
        contributionUniqueALaFormation: false,
        contributionEffortConstruction: false,

        stripeManual: false,
        stripeAuto: false,
        stripeConfig: {
            secretKey: "",
            webhookSecretKey: "",
        },

        mollieManual: false,
        mollieAuto: false,
        mollieConfig: {
            key: "",
        },

        accountingMail: false,
        accountingMailConfig: {
            users: [],
        },

        documentFromMail: false,
        documentFromMailConfig: {
            users: [],
        },

        sendingMailSMTP: false,
        sendingMailSMTPConfig: {
            users: [],
        },

        vatBankAccount: {
            id: null,
            name: null,
        },

        jeDeclareDotCom: false,
        jeDeclareDotComConfig: {
            auth: {
                username: "",
                password: "",
            },
        },
        rofs: [],
        ogaEnrolment: false,
        ogaEnrolmentConfig: {
            numberId: "",
            siret: "",
            designation: "",
            address: "",
            postalCode: "",
            city: "",
            year: "",
        },

        taxIntegration: false,
        paymentCreditCount: 0,
        activateTask: false,
        autoTaxTask: false,
        autoVATTask: false,

        workflow: {
            nodes: [],
            connections: [],
        },

        stock: false,
        stockConfig: {
            onlyInventory: false,
        },

        managementAuthorization: true,
        managementAuthorizations: {
            supplier: true,
            client: true,
            expenseReport: true,
            salary: true,
            operatingAccount: true,
            selectedClient: true,
        },

        mailCollectKey: null,
        mailCollect: false,
    };

    @Watch("profileId")
    setConfig() {
        if (this.profileId === undefined) {
            this.config = _.cloneDeep(this.defaultConfig);
        }
    }

    @Apollo({
        query: PROFILE_COMPANY,
        variables() {
            return {
                id: this.profileId,
            };
        },
        skip() {
            return !this.profileId;
        },
        specificResult({ data, loading, networkStatus }: any) {
            this.genericLoading_db = loading;
            if (!loading) {
                if (data && data.profileCompany) {
                    const tempoConfig: ProfileCompany = data.profileCompany;
                    // if (!tempoConfig.gmailConfig) {
                    //     tempoConfig.gmailConfig = {
                    //         users: []
                    //     }
                    // }
                    if (!tempoConfig.accountingMailConfig) {
                        tempoConfig.accountingMailConfig = {
                            users: [],
                        };
                    }
                    if (!tempoConfig.stripeConfig) {
                        tempoConfig.stripeConfig = undefined;
                    }
                    if (!tempoConfig.mollieConfig) {
                        tempoConfig.mollieConfig = undefined;
                    }
                    if (!tempoConfig.documentFromMailConfig) {
                        tempoConfig.documentFromMailConfig = {
                            users: [],
                        };
                    }
                    if (!tempoConfig.sendingMailSMTPConfig) {
                        tempoConfig.sendingMailSMTPConfig = {
                            users: [],
                        };
                    }
                    if (!tempoConfig.vatBankAccount) {
                        tempoConfig.vatBankAccount = { id: null, name: null };
                    }
                    if (!tempoConfig.accountingType) {
                        tempoConfig.accountingType = "RECEIVABLES_DEBT";
                    }
                    if (!tempoConfig.jeDeclareDotComConfig) {
                        tempoConfig.jeDeclareDotComConfig = {
                            auth: {
                                username: "",
                                password: "",
                            },
                        };
                    } else {
                        tempoConfig.jeDeclareDotComConfig.auth.password = "";
                    }
                    if (
                        tempoConfig.paymentCreditCount === null ||
                        tempoConfig.paymentCreditCount === undefined
                    ) {
                        tempoConfig.paymentCreditCount = 0;
                    }
                    if (!tempoConfig.taxIntegration) {
                        tempoConfig.taxIntegration = false;
                    }
                    // if (!tempoConfig.rofs || !tempoConfig.rofs.length) {
                    let tempoRofs = {};
                    if (tempoConfig?.rofs?.length) {
                        tempoConfig.rofs.forEach((rof) => {
                            tempoRofs[rof.tax] = rof.code;
                        });
                    }
                    tempoConfig.rofs = [
                        {
                            tax: "TVA",
                            prefix: "TVA",
                            code: tempoRofs["TVA"] || "1",
                        },
                        {
                            tax: "IS",
                            prefix: "IS",
                            code: tempoRofs["IS"] || "1",
                        },
                        {
                            tax: "CVAE",
                            prefix: "CVAE",
                            code: tempoRofs["CVAE"] || "1",
                        },
                        {
                            tax: "RCM",
                            prefix: "RCM",
                            code: tempoRofs["RCM"] || "1",
                        },
                        {
                            tax: "Liasse",
                            prefix: this.bundleRofPrefix,
                            code: tempoRofs["Liasse"] || "1",
                        },
                        {
                            tax: "Intégration fiscale",
                            prefix: "ISGROUPE",
                            code: tempoRofs["Intégration fiscale"] || "1",
                        },
                    ];

                    if (!tempoConfig.workflow) {
                        tempoConfig.workflow = {
                            nodes: [],
                            connections: [],
                        };
                    }
                    if (!tempoConfig.ogaEnrolmentConfig) {
                        tempoConfig.ogaEnrolmentConfig = {
                            numberId: "",
                            siret: "",
                            designation: "",
                            address: "",
                            postalCode: "",
                            city: "",
                            year: "",
                        };
                    }
                    if (tempoConfig.stock === null) {
                        tempoConfig.stock = false;
                    }
                    if (tempoConfig.stockConfig === null) {
                        tempoConfig.stockConfig = {
                            onlyInventory: false,
                        };
                    }
                    if (!tempoConfig?.stripeConfig?.secretKey) {
                        tempoConfig.stripeConfig = {
                            secretKey: "",
                            webhookSecretKey: "",
                        };
                    }

                    if (!tempoConfig?.managementAuthorizations) {
                        const status = tempoConfig.managementAuthorization || false;
                        tempoConfig.managementAuthorizations = {
                            supplier: status,
                            client: status,
                            expenseReport: status,
                            salary: status,
                            operatingAccount: status,
                            selectedClient: status,
                        };
                    }
                    if (!tempoConfig.mailCollectKey) {
                        tempoConfig.mailCollectKey = null;
                    }

                    this.config = tempoConfig;
                } else {
                    this.config = _.cloneDeep(this.defaultConfig);
                }
            }
        },
    })
    config: ProfileCompany = _.cloneDeep(this.defaultConfig);

    refresh() {
        if (this.$apollo.queries && this.$apollo.queries.config) {
            this.$apollo.queries.config.refetch();
        } else {
            debugger; // git-ignore
        }
    }

    getOfferStringValue(offer) {
        switch (offer) {
            case "ACCOUNTING_STARTER":
                return Offer_type.ACCOUNTING_STARTER;
            case "ACCOUNTING_BASIC":
                return Offer_type.ACCOUNTING_BASIC;
            case "ACCOUNTING_ESSENTIAL":
                return Offer_type.ACCOUNTING_ESSENTIAL;
            case "ACCOUNTING_PREMIUM":
                return Offer_type.ACCOUNTING_PREMIUM;
            case "TRAINING":
                return Offer_type.TRAINING;
            case "BUSINESS_BASIC":
                return Offer_type.BUSINESS_BASIC;
            case "BUSINESS_SMART":
                return Offer_type.BUSINESS_SMART;
            case "BUSINESS_ESSENTIAL":
                return Offer_type.BUSINESS_ESSENTIAL;
            case "BUSINESS_PREMIUM":
                return Offer_type.BUSINESS_PREMIUM;
        }
    }

    @Apollo({
        query: GET_COMPANY_OFFER,
        variables() {
            console.log("companyId", this.companyId);
            return {
                client: { id: this.companyId },
            };
        },
        fetchPolicy: "network-only",
        specificResult({ data, loading, networkStatus }: any) {
            if (!loading) {
                if (data.accountingFirmClients?.length) {
                    let lastDate: Date = null;
                    for (const accountingFirmClient of data.accountingFirmClients) {
                        if (
                            lastDate == null ||
                            lastDate.getTime() < new Date(accountingFirmClient.updatedAt).getTime()
                        ) {
                            this.offerType = this.getOfferStringValue(accountingFirmClient.offer);
                            lastDate = new Date(accountingFirmClient.updatedAt);
                        }
                    }
                }
            }
        },
    })
    offerType: Offer_type;
}

export default toNative(ConfigAPI);
</script>
